import { Tooltip } from 'antd'
import React from 'react'

const OfferAcceptedIcon = () => {
  return (
    <Tooltip title="Offer Accepted">
      <svg
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C5.20156 0 0.5 4.70156 0.5 10.5C0.5 16.2984 5.20156 21 11 21C16.7984 21 21.5 16.2984 21.5 10.5C21.5 4.70156 16.7984 0 11 0ZM11 19.2188C6.18594 19.2188 2.28125 15.3141 2.28125 10.5C2.28125 5.68594 6.18594 1.78125 11 1.78125C15.8141 1.78125 19.7188 5.68594 19.7188 10.5C19.7188 15.3141 15.8141 19.2188 11 19.2188Z"
          fill="#0FB680"
        />
        <path
          d="M9.625 6.125V7.375H13.7438L6.5 14.6187L7.38125 15.5L14.625 8.25625V12.375H15.875V6.125H9.625Z"
          fill="#0FB680"
        />
      </svg>
    </Tooltip>
  )
}

export default OfferAcceptedIcon
